import $ from "jquery"
import { trace } from "./helpers.js"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

const Dir = {
  
  initMasonry(index, grid) {
    let $grid = $(grid);
    if ($grid.length) {
      this.msnry = new Masonry( $grid.get(0), {
        itemSelector: '.masonry-item',
        columnWidth: '.masonry-item'
      });

      this.imgsL = new imagesLoaded($grid);
      this.imgsL.on("progress", ()=>{
        this.msnry.layout();
      });
    }
  },

  // ### init ###
  init() {
    // init masonry?
    $('.masonry-loader').each( this.initMasonry );
  }

}

export default Dir;